import { features } from '@/mocks/categories';

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300/60 bg-secondary-100/50 text-secondary-900 text-xs font-medium mb-4">
            Why Choose Us
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 mb-3">
            Why Thousands Use the AllChinaBuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            Thousands of buyers rely on the <strong>AllChinaBuy Spreadsheet</strong> to simplify their shopping experience — saving time, comparing sellers, and finding the <strong>best allchinabuy spreadsheet</strong> for their needs.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group bg-background-50 rounded-xl overflow-hidden hover:bg-primary-500 transition-all duration-300 cursor-default border border-background-200/60"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={feature.imageUrl}
                  alt={feature.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 text-primary-500 group-hover:bg-background-50/20 group-hover:text-background-50 transition-all duration-300 mb-3">
                  <i className={`${feature.icon} text-lg`}></i>
                </div>
                <h3 className="text-sm font-heading font-semibold text-foreground-950 group-hover:text-background-50 transition-colors mb-2">
                  {feature.title}
                </h3>
                <p className="text-xs text-foreground-500 group-hover:text-background-200 transition-colors leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}